import { ApiHelper } from './apiHelper';
import {
    EditNameEmailContent,
    EmailResponse
} from '../components/common/CommonTypes';

export class EmailApi {
    async SendEditNameEmailAsync(
        data: EditNameEmailContent,
        token: string,
        successCallback: (response: EmailResponse) => void,
        failureCallback: (response: EmailResponse) => void,
        signal: AbortSignal
    ): Promise<void> {
        const dataUrl = '/api/email/name';

        await new ApiHelper().postDataWithResponseSecure(
            dataUrl,
            data,
            token,
            successCallback,
            failureCallback,
            signal
        );
    }
}
